module.exports = __webpack_public_path__ + "static/media/leadership.f9809f27.png";